import ApiService from '@/services/core/api.service'

const DashboardService = {
  async get (query = '') {
    return ApiService.get(`disbursement-head/dashboard?${query}`)
  }
}

export default DashboardService
